export default "__VITE_ASSET__DCvCPby6__"